// file imports
import { IEvent, IPresentation } from '@/types';

interface StatsSectionProps {
  events: IPresentation[] | IEvent[];
  eventType: 'Event' | 'Presentation';
}

interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
}

function StatCard({ label, value, icon }: StatCardProps) {
  return (
    <div className="bg-white p-2 sm:p-4 rounded shadow text-center">
      <div className="text-lg sm:text-2xl">{icon}</div>
      <div className="text-lg sm:text-2xl font-semibold">{value}</div>
      <div className="text-xs sm:text-sm text-gray-500">{label}</div>
    </div>
  );
}

export default function StatsSection({ events, eventType }: StatsSectionProps) {
  const calculateStats = () => {
    const currentYear = new Date().getFullYear();
    const safeEvents = events || [];

    const totalRevenue = safeEvents
      .filter((p) => {
        const eventDate = eventType === 'Event' ? new Date((p as IEvent).startDate) : new Date((p as IPresentation).date);
        return eventDate.getFullYear() === currentYear && p.rate?.startsWith('$');
      })
      .reduce((sum, p) => {
        const numericRate = parseFloat((p.rate || '').replace(/[^0-9.-]+/g, '')) || 0;
        return sum + numericRate;
      }, 0);

    return [
      {
        label: 'Total Feedbacks',
        value: safeEvents.reduce((acc, p) => acc + (p.responses || 0), 0),
        icon: '😊',
      },
      {
        label: 'Total Events',
        value: safeEvents.length,
        icon: '🎤',
      },
      {
        label: 'Talks Booked This Year',
        value: `$${totalRevenue.toLocaleString()}`,
        icon: '💳',
      },
    ];
  };

  const statCards = calculateStats();

  return (
    <div className="grid grid-cols-3 gap-1 sm:gap-4 mb-4 sm:mb-6">
      {statCards.map(({ label, value, icon }) => (
        <StatCard key={label} label={label} value={value} icon={icon} />
      ))}
    </div>
  );
}
